import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import queryString from 'query-string';

import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';
import TicketSubmissionItemViewer from '../tickets/components/TicketSubmissionItemViewer';
import SimpleRateForm from './components/TicketBonusForm';
import ListPanel from './containers/ListPanel';
import { getTicketId } from './selectors';
import { setTicketId, setBonusMonth, setShowProcessedTickets } from './actions';

import { routerProps } from '../../propTypes';


const propTypes = exact({
  ticketId: PropTypes.number,
  setTicketIdAction: PropTypes.func.isRequired,
  setBonusMonthAction: PropTypes.func.isRequired,
  setShowProcessedTicketsAction: PropTypes.func.isRequired,
  ...routerProps,
});


const BonusTicketProcessor = (props) => {
  const { ticketId } = props;
  return (
    <React.Fragment>
      <PageLayout
        title="Bonus Ticket Inbox"
        render={() => {
          return (
            <SplitLayout
              leftSize={2}
              leftRender={() => { return <ListPanel />; }}
              rightSize={10}
              rightRender={() => {
                return (
                  <SplitLayout
                    leftSize={6}
                    leftRender={() => {
                      return (
                        <TicketSubmissionItemViewer ticketId={ticketId} />
                      );
                    }}
                    rightSize={6}
                    rightRender={() => {
                      return (
                        <SimpleRateForm ticketId={ticketId} />
                      );
                    }}
                  />
                );
              }}
            />
          );
        }}
      />
    </React.Fragment>
  );
};


BonusTicketProcessor.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    ticketId: getTicketId(state),
  };
};
const mapDispatchToProps = {
  setTicketIdAction: setTicketId,
  /* NOTE: setBonusMonth takes the value and sets it in state. */
  setBonusMonthAction: setBonusMonth,
  setShowProcessedTicketsAction: setShowProcessedTickets,
};

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      location,
      setTicketIdAction, setBonusMonthAction,
      setShowProcessedTicketsAction,
    } = this.props;
    const querySringObject = queryString.parse(location.search);

    const { bonusMonth, ticketId, showProcessed } = querySringObject;
    const ticketIdValue = parseInt(ticketId, 10);

    if (ticketId && !Number.isNaN(ticketIdValue)) {
      setTicketIdAction(ticketIdValue);
    }

    if (bonusMonth) {
      setBonusMonthAction(bonusMonth);
    }

    const showProcessedBool = (showProcessed === 'true');
    if (showProcessed) {
      setShowProcessedTicketsAction(showProcessedBool);
    }
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withInitPage,
);


export default enhance(BonusTicketProcessor);
